import React, { useState } from 'react';
import { HeaderBarStyle,  } from '../../style';
import {  CloseOutlined } from '@ant-design/icons';

import classNames from 'classnames';


const HeaderLayout = ({ getTheme, sidebarMode, }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <HeaderBarStyle
      style={{
        ...getTheme.sidebar[sidebarMode],
      }}
    >
      <div className="logo">
        <a href='https://applehouseth.com/'><img src={`../../../assets/images/logo-text.png`} alt="applesure" class="avatar-logo" /></a>
      </div>
      <div className="menu-bar">
        <div className="hamburger-menu">
          <div className={classNames('menu-toggle', { 'open': isOpen })} onClick={toggleMenu}>
            {isOpen ? (
              <div><CloseOutlined /></div>
            ) : (
              <>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </>
            )}

          </div>
          <ul className={classNames('nav-links', { 'open': isOpen })}>
            <li><a href="https://applehouseth.com/">ขายกับเรา</a></li>
            <li><a href="https://applehouseth.com/blog">ข่าวสารและโปรโมชัน</a></li>
            <li><a href="https://applehouseth.com/location">สาขาใกล้คุณ</a></li>
            <li><a href="https://applehouseth.com/contact-us">ติดต่อเรา</a></li>
          </ul>
        </div>
      </div>

    </HeaderBarStyle>
  );
};

export default HeaderLayout;
